import React, { useState, useEffect } from "react";
import "../styles/Hero.css";
import { useNavigate } from "react-router-dom";
const slides = [
  {
    title: "Global Banking Without Borders",
    desc: "Experience the freedom of offshore banking with secure multi-currency accounts accessible anywhere in the world. Manage your wealth globally, move funds seamlessly, and enjoy the privacy and flexibility trusted by international clients and high–net-worth individuals.",
    cta: "Open Offshore Account",
  },
  {
    title: "Private Wealth, Protected",
    desc: "Your assets deserve world-class protection. Our offshore banking infrastructure ensures maximum confidentiality, strong asset preservation, and compliance with the highest international financial standards. Secure your wealth beyond borders with a trusted financial partner.",
    cta: "Secure Your Assets",
  },
  {
    title: "Intelligent Global Transfers",
    desc: "Send and receive money across continents with real-time settlements and ultra-low fees. From private investments to corporate transactions, our global transfer network is built for speed, transparency, and total security.",
    cta: "Transfer Globally",
  },
  {
    title: "Invest Beyond Boundaries",
    desc: "Access global investment portfolios, offshore savings plans, and foreign currency deposits. Diversify your holdings, hedge against inflation, and grow your capital through a stable, internationally recognized financial hub.",
    cta: "Explore Investment Options",
  },
];

export default function Hero() {
  const [index, setIndex] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const slideInterval = setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 5000); // slower to appreciate the fade
    return () => clearInterval(slideInterval);
  }, []);

  return (
 <>
      <div className="hero">
        {slides.map((slide, i) => (
          <div
            key={i}
            className={`fade-slide ${i === index ? "active" : ""}`}
          >
            <div className="card-text">
              <h1>{slide.title}</h1>
              <p>{slide.desc}</p>
              <button
                onClick={() => navigate("/login")}
                className="hero-btn"
              >
                {slide.cta}
              </button>
            </div>
            <div className="card-img">
              {/* uncomment if you want background visuals */}
              {/* <img src={slide.img} alt={slide.title} /> */}
            </div>
          </div>
        ))}
      </div>

 </>
  );
}
